import type { JobContacts } from 'features/jobs/types'

export const JOB_REDUCER_NAME = 'job'
export const JOB_INFO_REDUCER_NAME = 'jobInfo'
export const JOB_INFO_IMAGES_REDUCER_NAME = 'jobInfoImages'

export const jobInitialContacts: JobContacts = {
  role: '',
  phone: '',
  name: '',
  email: '',
}

export const DOMAIN_API_ERROR = {
  DOMAIN_JOB_EXISTS: 'DOMAIN_046',
  DOMAIN_HAS_NESTED_DOMAINS: 'DOMAIN_004',
}

export const SUPPORTED_IMAGE_MIME_TYPES = [
  'image/bmp',
  'image/gif',
  'image/webp',
  'image/png',
  'image/jpeg',
  'image/jpg',
]
